import React, { useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Paper,
} from '@mui/material';

const DataTable = ({ headers, rows }) => {
  const [order, setOrder] = useState('asc'); // Sorting order ('asc' or 'desc')
  const [orderBy, setOrderBy] = useState(''); // Column to sort by

  // Handle sorting when a column header is clicked
  const handleSort = (columnIndex) => {
    if (orderBy === columnIndex) {
      setOrder(order === 'asc' ? 'desc' : 'asc'); // Toggle sorting order
    } else {
      setOrderBy(columnIndex); // Set the column to sort by
      setOrder('asc'); // Default to ascending order
    }
  };

  // Sort rows based on the selected column and order
  const sortedRows = [...rows].sort((a, b) => {
    const aValue = a[orderBy] ?? ""; // Fallback to an empty string if undefined or null
    const bValue = b[orderBy] ?? ""; // Fallback to an empty string if undefined or null
  
    // Compare numeric or string values
    if (typeof aValue === "number" && typeof bValue === "number") {
      return order === "asc" ? aValue - bValue : bValue - aValue;
    } else {
      return order === "asc"
        ? aValue.toString().localeCompare(bValue.toString())
        : bValue.toString().localeCompare(aValue.toString());
    }
  });

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {headers.map((header, index) => (
              <TableCell key={index}>
                <TableSortLabel
                  active={orderBy === index} // Highlight the active sorting column
                  direction={orderBy === index ? order : 'asc'} // Show sorting direction
                  onClick={() => handleSort(index)} // Handle sorting on click
                >
                  {header}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex}>
                  {cell !== null && cell !== undefined ? cell : "N/A"}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DataTable;